import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// external-global styles must be imported in your JS.
import s from './ContentContainer.css';

class ContentContainer extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }
  render() {
    return (
      <Fragment>
        <div className={ this.props.myClass === "no_margin" ? s.no_margin : s.container}>{this.props.children}</div>
      </Fragment>
    );
  }
}

export default withStyles(s)(ContentContainer);
